import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function usePostLikesQuery(postId, options) {
  return useQuery(QUERY_CACHE_KEY.postLikes(postId), options);
}

export default usePostLikesQuery;
